import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 23.57 23.571" {...props}>
      <defs>
        <style>
          {`.prefix__prefix__cls-menudnaicon,.prefix__prefix__cls-2menudnaicon{fill:none;stroke:${props.color};stroke-miterlimit:10}.prefix__prefix__cls-2menudnaicon{stroke-linecap:round}`}
        </style>
      </defs>
      <g
        id="prefix__prefix__Group_2515"
        data-name="Group 2515"
        transform="rotate(-135 8.37 10.202)"
      >
        <path
          id="prefix__prefix__Path_2462"
          d="M9.669 6.669c0 4.446-4.835 6.669-4.835 6.669S0 11.116 0 6.669 4.835 0 4.835 0s4.834 2.223 4.834 6.669z"
          className="prefix__prefix__cls-menudnaicon"
          data-name="Path 2462"
          transform="translate(0 4.813)"
        />
        <path
          id="prefix__prefix__Path_2463"
          d="M9.079 0c-1.051 3.209-4.54 4.814-4.54 4.814S1.05 3.209 0 0"
          className="prefix__prefix__cls-menudnaicon"
          data-name="Path 2463"
          transform="translate(.295)"
        />
        <path
          id="prefix__prefix__Path_2464"
          d="M0 4.831C1.043 1.61 4.545 0 4.545 0s3.506 1.612 4.547 4.836"
          className="prefix__prefix__cls-menudnaicon"
          data-name="Path 2464"
          transform="translate(.29 18.152)"
        />
        <g
          id="prefix__prefix__Group_1892"
          data-name="Group 1892"
          transform="translate(.223 .367)"
        >
          <path
            id="prefix__prefix__Line_270"
            d="M0 0h9.21"
            className="prefix__prefix__cls-menudnaicon"
            data-name="Line 270"
          />
          <path
            id="prefix__prefix__Line_271"
            d="M0 0h5.526"
            className="prefix__prefix__cls-menudnaicon"
            data-name="Line 271"
            transform="translate(1.842 2.223)"
          />
        </g>
        <g
          id="prefix__prefix__Group_1893"
          data-name="Group 1893"
          transform="translate(.631 20.376)"
        >
          <path
            id="prefix__prefix__Line_272"
            d="M0 0h8.456"
            className="prefix__prefix__cls-2menudnaicon"
            data-name="Line 272"
            transform="translate(0 2.223)"
          />
          <path
            id="prefix__prefix__Line_273"
            d="M0 0h5.526"
            className="prefix__prefix__cls-2menudnaicon"
            data-name="Line 273"
            transform="translate(1.434)"
          />
        </g>
        <path
          id="prefix__prefix__Line_274"
          d="M0 0h8.593"
          className="prefix__prefix__cls-menudnaicon"
          data-name="Line 274"
          transform="translate(.223 11.483)"
        />
        <path
          id="prefix__prefix__Line_275"
          d="M0 0h8.024"
          className="prefix__prefix__cls-menudnaicon"
          data-name="Line 275"
          transform="translate(.223 9.26)"
        />
        <path
          id="prefix__prefix__Line_276"
          d="M0 0h4.476"
          className="prefix__prefix__cls-menudnaicon"
          data-name="Line 276"
          transform="translate(3.293 7.037)"
        />
        <path
          id="prefix__prefix__Path_3646"
          fill="none"
          stroke={props.color}
          d="M0 0h4.476"
          data-name="Path 3646"
          transform="translate(3.293 15.929)"
        />
        <path
          id="prefix__prefix__Line_278"
          d="M0 0h8.024"
          className="prefix__prefix__cls-menudnaicon"
          data-name="Line 278"
          transform="translate(.223 13.706)"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
